import { useEffect } from "react";

function useClickOutside(
  ref: React.RefObject<HTMLElement | null>,
  methodToRunWhenClickOutside: (e?: MouseEvent) => void,
  exemptedIds: string[] = []
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      // Explicit null check (TypeScript will now understand ref.current could be null)
      if (!ref.current) return;

      const isClickOutside = !ref.current.contains(event.target as Node);

      // Check if the clicked element or any of its ancestors have an exempted ID
      const isAnElementAllowedToClose = exemptedIds.some((id) => {
        let element = event.target as HTMLElement | null;
        while (element) {
          if (element.id === id) {
            return true;
          }
          element = element.parentElement;
        }
        return false;
      });

      // Only run the method if the click is outside and not exempted
      if (isClickOutside && !isAnElementAllowedToClose) {
        methodToRunWhenClickOutside(event);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, methodToRunWhenClickOutside, exemptedIds]);
}

export default useClickOutside;
